import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-no-access',
	templateUrl: './no-access.component.html',
	styleUrls: ['./no-access.component.css']
})
export class NoAccessComponent implements OnInit {
	constructor() {}

	ngOnInit() {}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/no-access/no-access.component.ts